import React from 'react';
import { Fieldset } from 'react-redux-form';
import { enumTrustedContactRelationship } from '../Schemas/baseRrf';
import InputField from '../Controls/Field';
import getTrustedContactFields from './TrustedContactFields';

const TrustedContact = ({ addrPath }) => {
  const fields = getTrustedContactFields();
  return (
    <Fieldset model={addrPath}>
      {fields.map((field, i) => (i < 4 ?
        <InputField key={field.model} fieldProps={field} /> : null))}
      <InputField key={fields[4].model} fieldProps={fields[4]}>
        {enumTrustedContactRelationship.map(item => (
          <option key={item[1]} label={item[1]} value={item[0]}>{item[1]}</option>
        ))}
      </InputField>
    </Fieldset>
  );
};

export default TrustedContact;



// WEBPACK FOOTER //
// ./src/components/Forms/TrustedContact/index.js